import React from 'react';

// Material UI
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import FilterListIcon from '@mui/icons-material/FilterList';

// Components
import Dropdown from "../../../components/inputs/dropdown";

import WrapperDatePicker from '../../../components/wrapperDatapicker';

import useStyles from "./styles";
import { typesSelect, subTypesSelect, cashTypesSelect } from '../../../models/CashRegisterMovementEntity';

const CashRegisterMovementsFilters = ({ filters, clearFilters, onFilterChange, cashRegisters, currencies }) => {
    const { classes } = useStyles();

    return (
        <Paper className={classes.paperFullWidth} style={{ marginTop: '20px' }}>
            <Grid container spacing={1}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 2
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary'> Seleccionar caja: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                name='cashRegisterId'
                                label='Caja'
                                onChange={onFilterChange}
                                size='small'
                                getOptionLabel={(option) => `${option?.name}`}
                                getOptionValue={(option) => option?.id}
                                values={[{ name: 'Todas', id: '-1' }].concat(cashRegisters)}
                                value={filters?.cashRegisterId || '-1'}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por fecha: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.from}
                                handleFilterChange={onFilterChange}
                                type="from"
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: 6
                            }}
                        >

                            <WrapperDatePicker
                                filters={filters?.to}
                                handleFilterChange={onFilterChange}
                                type="to"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 4
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por tipo de movimiento: </Typography>
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='type'
                                label='Tipo'
                                onChange={onFilterChange}
                                size='small'
                                values={typesSelect}
                                value={filters?.type || ''}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6
                            }}
                        >
                            <Dropdown
                                fullWidth
                                name='subType'
                                label='Sub Tipo'
                                size='small'
                                onChange={onFilterChange}
                                values={subTypesSelect}
                                value={filters?.subType || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        md: 2,
                        sm: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por medio de pago: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                name='cashType'
                                label='Sub Tipo'
                                size='small'
                                onChange={onFilterChange}
                                values={cashTypesSelect}
                                value={filters?.cashType || ''}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        md: 2,
                        sm: 6
                    }}
                >
                    <Grid container spacing={1}>
                        <Grid size={12}>
                            <Typography variant='inherit' color='primary' style={{ display: 'block' }}> Filtrar por moneda: </Typography>
                        </Grid>
                        <Grid size={12}>
                            <Dropdown
                                fullWidth
                                name='currency'
                                label='Moneda'
                                size='small'
                                getOptionLabel={(option) => option?.name}
                                getOptionValue={(option) => option?.id}
                                onChange={onFilterChange}
                                values={currencies}
                                value={filters?.currency || '-1'}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid
                    className={classes.rootFab}
                    size={{
                        xs: 12,
                        sm: 8,
                        md: 10
                    }}
                >
                    <Button
                        color="primary"
                        variant="outlined"
                        onClick={clearFilters}
                        className={classes.button}
                        startIcon={<FilterListIcon />}
                    >
                        Limpiar
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default CashRegisterMovementsFilters;